import { PerspectiveCamera } from "@react-three/drei"
import { moveAxisRange, rotateAxisRange, moveAxis } from '../../../utils/moveObjects'
import { useFrame } from "@react-three/fiber"
import { useActsStore } from "../../../store/useActsStore"
import { useIsMobile } from "../../../utils/useIsMobile"


export default function CameraTwo({ innerRef }) {
    const isMobile = useIsMobile()

    const camPos = isMobile ? [-1, 0, 15] : [0, 0, 5]
    const camRot = [0, 0, 0]

    const offSetX = isMobile ? 21 : 20

    useFrame((_, delta) => {
        const stateActe = useActsStore.getState()
        const id = stateActe.getCurrentActId()

        const holdProgress = stateActe.actsProgress[id]?.holdProgress ?? 0
        if (id === 1) {
            if (!innerRef.current) return
            moveAxisRange(innerRef, 'x', camPos[0], offSetX, holdProgress, 0.2, 0.5,6, delta)
            moveAxisRange(innerRef, 'z', camPos[2], 8, holdProgress, 0.4, 0.5,6, delta)
            
        }
        else return
    })
    return (
        <PerspectiveCamera
            ref={innerRef}
            position={camPos}
            rotation={camRot}
            near={0.1}
        />
    )
}